import type { ApiLoginResponse } from "@types_def/common/auth.types";

import axios from "axios";

export function setToken() {
  const accessToken: string | null =
    typeof window !== "undefined" ? localStorage.getItem("AccessToken") : null;
  axios.defaults.headers.common.Authorization = accessToken || "no-token";
}

export function storeAuthResult(response: ApiLoginResponse) {
  localStorage.setItem("AccessToken", response.AuthenticationResult.IdToken);
  if (response.AuthenticationResult.RefreshToken) {
    localStorage.setItem("RefreshToken", response.AuthenticationResult.RefreshToken);
  }
  // Store expiration time for proactive refresh (ExpiresIn is in seconds)
  const expiresAt = Date.now() + response.AuthenticationResult.ExpiresIn * 1000;
  localStorage.setItem("TokenExpiresAt", expiresAt.toString());

  setToken();
}

export function getTokenExpirationTime(): number | null {
  const expiresAt = localStorage.getItem("TokenExpiresAt");
  return expiresAt ? Number.parseInt(expiresAt, 10) : null;
}

export function isTokenExpiringSoon(bufferMs: number = 5 * 60 * 1000): boolean {
  const expiresAt = getTokenExpirationTime();
  if (!expiresAt) return false;
  return Date.now() >= expiresAt - bufferMs;
}

export function removeAuth() {
  localStorage.removeItem("RefreshToken");
  localStorage.removeItem("AccessToken");
  setToken();
  //
}
